/*
 * Copyright: Infosim GmbH & Co. KG Copyright (c) 2000-2021
 * Company: Infosim GmbH & Co. KG,
 *                  Landsteinerstraße 4,
 *                  97074 Wuerzburg, Germany
 *                  www.infosim.net
 */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, first, map } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  isLoading = false;

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const fragment = state.url.split('#')[1]?.split('?')[0];
    const queryParams = {
      ..._route.queryParams,
      continue: state.url.split(/[#?]/g)[0],
      ...(fragment ? { fragment } : {}),
    };

    this.isLoading = true;
    return this.authService.tryLogin().pipe(
      first(),
      map((res) => {
        this.isLoading = false;

        if (res) {
          return true;
        }

        this.router.navigate(['/login'], { queryParams });
        return false;
      }),
      catchError(() => {
        this.isLoading = false;
        this.router.navigate(['/login'], { queryParams });
        return of(false);
      })
    );
  }
}
